// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideVolume2 as RawLucideVolume2 } from "lucide-react";
export const LucideVolume2 = /* @__PURE__ */ createIcon(RawLucideVolume2, "LucideVolume2", 2);
